import React from 'react';
import { Form, Input, Button } from 'antd';

interface ResetPasswordFormProps {
  isLoading?: boolean;
  onSubmit: (user: string) => void;
  onBackToLogin: () => void;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({
  isLoading,
  onSubmit,
  onBackToLogin,
}) => {
  const handleSubmit = (data: any) => {
    onSubmit(data.username);
  };

  return (
    <Form
      name="restore-password"
      layout="vertical"
      initialValues={{ remember: true }}
      onFinish={handleSubmit}
    >
      <Form.Item
        label="Username or email address"
        name="username"
        rules={[{ required: true, message: 'Please input your username!' }]}
      >
        <Input size="large" disabled={isLoading} />
      </Form.Item>

      <Button
        size="large"
        type="primary"
        disabled={isLoading}
        htmlType="submit"
      >
        Reset
      </Button>
      <Button
        type="link"
        htmlType="button"
        disabled={isLoading}
        onClick={onBackToLogin}
      >
        Back to login
      </Button>
    </Form>
  );
};

export default ResetPasswordForm;
